import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'
// import { isArray } from '@/utils/validate'
import { BASE_URL } from './config';

import { globals } from '@/main'

const contentType= 'application/json;charset=UTF-8'
const messageName='msg'
const statusName='code'
const requestTimeout=60*1000
const baseURL= BASE_URL//process.env.VUE_APP_BASE_API
// const successCode=[200, 0, '200', '0', '000000']
// 操作正常Code数组
// const codeVerificationArray = isArray(successCode)
//   ? [...successCode]
//   : [...[successCode]]
console.log(globals.$Emessage ,'$Emessage $Emessage ')
const CODE_MESSAGE = {
  200: '服务器成功返回请求数据',
  201: '新建或修改数据成功',
  202: '一个请求已经进入后台排队(异步任务)',
  204: '删除数据成功',
  400: '发出信息有误',
  401: '用户没有权限(令牌失效、用户名、密码错误、登录过期)',
  402: '令牌过期',
  403: '用户得到授权，但是访问是被禁止的',
  404: '访问资源不存在',
  406: '请求格式不可得',
  410: '请求资源被永久删除，且不会被看到',
  500: '服务器发生错误',
  502: '网关错误',
  503: '服务不可用，服务器暂时过载或维护',
  504: '网关超时',
}

/**
 * axios请求拦截器配置
 * @param config
 * @returns {any}
 */
const requestConf= (config) => {
  console.log(config,'config')
const  token  = localStorage.getItem('token')
if (token) config.headers['token'] = `${token}`
return config
}



/**
 * axios响应拦截器
 * @param config 请求配置
 * @param data response数据
 * @param status HTTP status
 * @param statusText HTTP status text
 * @returns {Promise<*|*>}
 */

const handleData = async ({ config, data, status, statusText }) => {
  console.log(config)
  // 若data.code存在，覆盖默认code
  let code = data && data[statusName] ? data[statusName] : status
  // 若code属于操作正常code，则status修改为200
  console.log(data,status,code)
  switch (code) {
    case 200:
  
      return data
    case 403:
      globals.$Emessage =  ElMessage({
        dangerouslyUseHTMLString: true,
        duration: 3000,
        message: '<strong>系统消息</strong><p>'+'您的登陆已过期，请重新登录'+'</p>',
      })
      // ElMessage.error('您的登陆已过期，请重新登录')
      localStorage.removeItem('token')
      router.push({ path: '/login', replace: true }).then(() => {})
      break
  }
  // 异常处理
  // 若data.msg存在，覆盖默认提醒消息
  const errMsg = `${
    data && data[messageName]
      ? data[messageName]
      : CODE_MESSAGE[code]
      ? CODE_MESSAGE[code]
      : statusText
  }`
  console.log(errMsg)
  if (code == 400) {
    console.log(errMsg,code,'344')
    // ElMessage.error(errMsg)
    globals.$Emessage = ElMessage({
      dangerouslyUseHTMLString: true,
      duration: 3000,
      message: '<strong>系统消息</strong><p>'+errMsg+'</p>',
    })
  
  }

  return Promise.reject(data)
}

/**
 * @description axios初始化
 */
const instance = axios.create({
  baseURL,
  timeout: requestTimeout,
  headers: {
    'Content-Type': contentType,
  },
})

/**
 * @description axios请求拦截器
 */
instance.interceptors.request.use(requestConf, (error) => {
  return Promise.reject(error)
})

/**
 * @description axios响应拦截器
 */
instance.interceptors.response.use(
  (response) => handleData(response),
  (error) => {
    const { response } = error
    console.log(response,error,'232')
    if (response === undefined) {
      // router.push({ path: '/login', replace: true }).then(() => {})
      // ElMessage.error('系统繁忙，请稍后再试')
      globals.$Emessage =   ElMessage({
        dangerouslyUseHTMLString: true,
        duration: 3000,
        message: '<strong>系统消息</strong><p>'+'系统繁忙，请稍后再试'+'</p>',
      })
      // localStorage.removeItem('token')
    return Promise.reject(error)
    } else return handleData(response)
  }
)

export default instance
